module.exports = __webpack_public_path__ + "static/media/home-carousel2.01607810.webp";